module.exports = __webpack_public_path__ + "img/new-logo-blitzpay.dfd53e32.svg";